/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Public_Site_Filter_Any_CategoryInputs */

const cs_public_site_filter_any_category = /** @type {(inputs: Public_Site_Filter_Any_CategoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prodej i pronájem`)
};

const en_public_site_filter_any_category = /** @type {(inputs: Public_Site_Filter_Any_CategoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sale & rent`)
};

/**
* | output |
* | --- |
* | "Sale & rent" |
*
* @param {Public_Site_Filter_Any_CategoryInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const public_site_filter_any_category = /** @type {((inputs?: Public_Site_Filter_Any_CategoryInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Public_Site_Filter_Any_CategoryInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_public_site_filter_any_category(inputs)
	return cs_public_site_filter_any_category(inputs)
});